export const MSC_BELLISSIMA_CANCEL_NOTICE =
  "※ 2027년 1월부터 운항하는 모든 MSC 벨리시마 부산 출도착 항차는 한국 시간 기준 2026년 6월 15일 00시 01분 이후 생성된 신규 예약부터 출발일 75일 전까지 취소 시에도 총 예약 금액의 5%가 환불 불가 금액으로 적용됩니다. 출발일 75일 이내 취소 시에는 기존 취소료 규정이 동일하게 적용됩니다.";

export const MSC_JAPAN_DEPARTURE_TAX_NOTICE =
  "※ 일본 기항지가 포함된 일정의 경우, 2026년 7월 1일 이후 예약자부터 일본 출국 1회당 1인 ￥3,000의 출국세가 달러로 환산되어 선내 계정에 부과됩니다.";

const MSC_CANCELLATION_NOTICES = [MSC_BELLISSIMA_CANCEL_NOTICE, MSC_JAPAN_DEPARTURE_TAX_NOTICE];
const MSC_LINE_ID = 16;

const normalizeNumber = (value) => {
  const parsed = Number(String(value ?? '').trim());
  return Number.isFinite(parsed) ? parsed : null;
};

export const isMscCancellationNoticeTarget = (context = {}) =>
  normalizeNumber(context.lineId ?? context.line_id) === MSC_LINE_ID;

export const isMscBellissimaBusanWinter2027 = isMscCancellationNoticeTarget;

export const withMscBellissimaCancelNotice = (terms, context = {}) => {
  if (!isMscCancellationNoticeTarget(context)) return terms;
  if (!Array.isArray(terms)) return terms;

  return terms.map((section) => {
    if (section?.title !== '취소료 규정' || !Array.isArray(section.items)) return section;
    if (MSC_CANCELLATION_NOTICES.every((notice) => section.items.some((item) => item?.text === notice || item === notice))) {
      return section;
    }

    return {
      ...section,
      items: [
        ...MSC_CANCELLATION_NOTICES.map((text) => ({ type: "note", text })),
        ...section.items.filter((item) => !MSC_CANCELLATION_NOTICES.includes(item?.text ?? item)),
      ],
    };
  });
};
